import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { interval, Subscription } from 'rxjs';
import { MatStepper } from '@angular/material/stepper';
import { MfaService } from './mfa.service';
import{ Modal} from 'bootstrap';

// declare var jQuery: any;

export enum MFASteps {
  Start = 0,
  // TwoStepAuthentication = 1,
  VerifyOTP
}

@Component({
    selector: 'app-mfa',
    templateUrl: './mfa.component.html',
    styleUrls: ['./mfa.component.scss'],
    providers: [MfaService],
    standalone: false
})
export class MfaComponent implements OnInit, OnDestroy  {
    selectedIndex: number = 0;
    mfaSteps = MFASteps;
    userEmailId: string;

    modalMessage: string = '';

    loading = false;

    @Input() sessionId: string
    @Input() userName: string
    @Input() password: string
    
    @Output()  onLogin = new EventEmitter<any>();
    @Output()  onCancel = new EventEmitter();

    @ViewChild('stepper') stepper: MatStepper;
    @ViewChild('inp1') inp1: ElementRef;
    @ViewChild('inp2') inp2: ElementRef;
    @ViewChild('inp3') inp3: ElementRef;
    @ViewChild('inp4') inp4: ElementRef;
    @ViewChild('verifyBtn') verifyBtn: ElementRef;

    mfaOptionErrorFlag = false;
    otpVerifyErrorMsg: string = '';

    startFormGroup = this._formBuilder.group({
      firstCtrl: [''],
    });

    authTypeFormGroup = this._formBuilder.group({
      mfaType: ['Email'],
    });

    verifyOtpFormGroup = this._formBuilder.group({
      inp1: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      inp2: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      inp3: ['', [Validators.required, Validators.pattern('^[0-9]$')]],
      inp4: ['', [Validators.required, Validators.pattern('^[0-9]$')]]
    });

    timerSubscription: Subscription;
    timeLeft: number = 0; // 5 minutes in seconds
    displayTime: string;

    isResendAllowed: boolean = false;

    constructor(private _formBuilder: FormBuilder, private mfaService: MfaService) {
      this.userEmailId = "";
    }

    ngOnInit() {
      
    }

    ngAfterViewInit() {
      this.stepper.selectionChange.subscribe((event) => {
        this.selectedIndex = event.selectedIndex;
      });
    }

    private moveToNextStep() {
      this.stepper.next();
    }
  
    // private moveToPreviousStep() {
    //   if(this.selectedIndex === this.mfaSteps.TwoStepAuthentication) {
    //     this.authTypeFormGroup.reset();
    //   }
    //   else if(this.selectedIndex === this.mfaSteps.VerifyOTP) {
    //     this.verifyOtpFormGroup.reset();
    //   }

    //   this.stepper.previous();
    // }

    public onCancelBtnClick() {
      this.onCancel.emit();
    }

    public onProceedBtnClick() {
      this.loading = true;

      this.mfaService.generateOTP(this.sessionId, this.authTypeFormGroup.value.mfaType).subscribe((response) => {
        if(response && response['status'] === 'Success') {
          this.userEmailId = response['emailId'];
          this.timeLeft = response['expirySeconds'];
          this.isResendAllowed = response['resendAllowed'];

          this.startTimer();
          this.moveToNextStep(); 
          this.loading = false;
          setTimeout(() => { 
            this.inp1.nativeElement.focus();
          }, 0);
        }
      },
        (error) => {
          this.loading = false;
            if(error && error.error["status"] === "Invalid Email Address"){
              this.modalMessage = 'The email address provided is either invalid or unavailable. If you did not receive the code via email or have any other questions, please reach out to our Provider Relations team at ProviderRelations@caremore.com or call (888) 291-1358, Option 5 for further assistance.';
              
              this.openModal('exceptionModal');
            } 
      }); 
    }

    // public onGetOtpBtnClick() {
    //   this.mfaService.generateOTP(this.sessionId, this.authTypeFormGroup.value.mfaType).subscribe((response) => {
    //     if(response && response['status'] === 'Success') {
    //       this.userEmailId = response['message'];
    //       this.moveToNextStep(); 
    //     }
    //   },
    //     (error) => {
    //         if(error && error.error["status"] === "Invalid Email Address"){
    //            this.mfaOptionErrorFlag  = true;
    //         } 
    //     }); 
    // }

    onResendCodeClick() {
      this.loading = true;
      this.isResendAllowed = false;
      this.mfaService.generateOTP(this.sessionId, this.authTypeFormGroup.value.mfaType).subscribe((response) => {
        if(response && response['status'] === 'Success') {
          this.userEmailId = response['emailId'];
          this.timeLeft = response['expirySeconds'];
        }
        this.loading = false;
      },
      (error) => {
        console.error('Error resending OTP:', error);
        this.isResendAllowed = true;
        this.loading = false;
      });
    }

    public onVerifyBtnClick() {
      this.otpVerifyErrorMsg = '';
      
      const otp = '' + this.verifyOtpFormGroup.value.inp1 + this.verifyOtpFormGroup.value.inp2 + 
          this.verifyOtpFormGroup.value.inp3 + this.verifyOtpFormGroup.value.inp4;

      if(otp.length != 4) {
        this.otpVerifyErrorMsg = 'Please enter the OTP received on your email address!';
        return;
      }

      this.loading = true;

      this.mfaService.verifyOTP(this.sessionId, otp, this.userName, this.password).subscribe((data) => {
        this.loading = false;
          if(data && data['status'] === 'Success') {
            const response = {
              status: 'Success',
              data: data
            }
            this.onLogin.emit(response);
          }
      },
      (error) => {
          this.loading = false;
          if(error && error.error["status"] === "Wrong OTP"){
            this.otpVerifyErrorMsg = 'The OTP you entered is invalid. Please enter the correct OTP!';
            this.timeLeft = 30;
          } 
          else if(error && error.error["status"] === "Reached Max Attempts"){
            this.modalMessage = 'The OTP you entered is invalid and you have reached the maximum number of unsuccessful attempts. Please try again later!';
           
            this.openModal('exceptionModal');
          } 
          else {
            const response = {
              status: 'Error',
              data: error.error
            }
            this.onLogin.emit(response);
          }
      }); 
    }

    onExceptionModalClose() {
      this.closeModal('exceptionModal');
      this.onCancel.emit();
    }

    private startTimer() {
      this.timerSubscription = interval(1000).subscribe(() => {
        if (this.timeLeft > 0) {
          this.timeLeft--;
          this.displayTime = this.formatTime(this.timeLeft);
        } else {
          this.stopTimer();
          this.modalMessage = 'OTP has expired. Please try again.';
          this.openModal('exceptionModal');
        }
      });
    }
  
    private stopTimer() {
      if (this.timerSubscription) {
        this.timerSubscription.unsubscribe();
      }
    }
  
    private formatTime(seconds: number): string {
      const minutes: number = Math.floor(seconds / 60);
      const remainingSeconds: number = seconds % 60;
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    }
  
    public onInput(event: Event) {
      const input = event.target as HTMLInputElement;
      const newValue = input.value.slice(0, 1);

      if (input.value.length > 1) {
        this.verifyOtpFormGroup.get(input.id).setValue(newValue);
      }

      if (newValue.length === 1) {
        this.moveToNextInput(input);
      }
    }

    private setFocusAndSelect(input: ElementRef) {
      input.nativeElement.focus();
      input.nativeElement.select();
    }
  
    private moveToNextInput(input: HTMLInputElement) {
      switch (input.id) {
        case 'inp1':
          this.setFocusAndSelect(this.inp2);
          break;
        case 'inp2':
          this.setFocusAndSelect(this.inp3);
          break;
        case 'inp3':
          this.setFocusAndSelect(this.inp4);
          break;
        case 'inp4':
          setTimeout(() => {
            this.verifyBtn.nativeElement.focus();
          }, 0);
          break;
      }
    }

    public onKeydown(event: KeyboardEvent) {
      if(["e", "E", "+", "-"].includes(event.key)) {
        event.preventDefault()
      }
    }
      openModal(modalId: string) {
            const modal = new Modal(document.getElementById(modalId));
            modal.show();
        }
        
        closeModal(modalId: string) {
          const modalElement = document.getElementById(modalId);
            const  modal = Modal.getInstance(modalElement);
            if(modal!=null){
              modal.hide();
            }
        }

    ngOnDestroy() {
      this.stopTimer();
    }
}